// services/task/TaskService.ts
import { BaseService } from "@services/BaseService";

class TaskService extends BaseService {
  /**
   * Fetch all tasks with optional query parameters
   * @param query Optional object containing `state` and/or `task_name`
   */

  getAllTasks(query?: { state?: string; task_name?: string }) {
    const params = new URLSearchParams();

    if (query?.state) {
      params.append("state", query.state);
    }

    if (query?.task_name) {
      params.append("task_name", query.task_name);
    }

    const queryString = params.toString();
    const url = queryString ? `/tasks/tasks/?${queryString}` : `/tasks/tasks/`;

    return this.get(url);
  }

  /**
   * Fetch only report generation tasks, optionally filtered by state
   */
  getReportTasks(state?: string) {
    return this.getAllTasks({
      state,
      task_name: "theark.workers.report_worker.generate_report",
    });
  }

  /**
   * Fetch only anomaly detection tasks, optionally filtered by state
   */
  getAnomalyDetectionTasks(state?: string) {
    return this.getAllTasks({
      state,
      task_name: "theark.workers.anomaly_detection_worker.detect_anomalies",
    });
  }

  deleteTask(taskId: string) {
    return this.delete(`/tasks/tasks/${taskId}`);
  }
}

export const taskService = new TaskService();
